module.exports = __webpack_public_path__ + "img/DSC_2772.ee691fdb.png";